import { notification } from "antd";
import dayjs from "dayjs";
import Helper from "../../Helper";
import { ScheduledReport } from "../../models/ScheduledReport";
import { plotFetch } from "../Helper/ApiRequest";

export const getScheduledReports = (subdomain: string, projectToken: string): Promise<ScheduledReport[]> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/scheduled_reports`;

    return plotFetch(url)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Network error.");
            }
        })
        .then((response) => {
            const timezone = dayjs.tz.guess();
            return response.map((report: any) => ScheduledReport.fromApiObject(report, timezone));
        })
        .catch(() => {
            notification.error({
                message: "Failed to get scheduled reports",
                description: "Please try again later",
            });
        });
};

export const createScheduledReport = (
    subdomain: string,
    projectToken: string,
    scheduledReport: ScheduledReport
): Promise<ScheduledReport | null> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/scheduled_reports`;

    return plotFetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(scheduledReport.toApiObject()),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Network error.");
            }
        })
        .then((response) => {
            const timezone = dayjs.tz.guess();
            return ScheduledReport.fromApiObject(response, timezone);
        })
        .catch(() => {
            notification.error({
                message: "Failed to create scheduled report",
                description: "Please try again later",
            });
            return null;
        });
};

export const updateScheduledReport = (
    subdomain: string,
    projectToken: string,
    scheduledReport: ScheduledReport
): Promise<ScheduledReport | null> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/scheduled_reports/${scheduledReport.id}`;

    return plotFetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(scheduledReport.toApiObject()),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Network error.");
            }
        })
        .then((response) => {
            const timezone = dayjs.tz.guess();
            return ScheduledReport.fromApiObject(response, timezone);
        })
        .catch(() => {
            notification.error({
                message: "Failed to update scheduled report",
                description: "Please try again later",
            });
            return null;
        });
};

export const deleteScheduledReport = (subdomain: string, projectToken: string, reportId: number): Promise<boolean> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/scheduled_reports/${reportId}`;

    return plotFetch(url, {
        method: "DELETE",
    })
        .then((response) => {
            if (response.ok) {
                return true;
            } else {
                throw new Error("Network error.");
            }
        })
        .catch(() => {
            notification.error({
                message: "Failed to delete scheduled report",
                description: "Please try again later",
            });
            return false;
        });
};
